import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface FilterGroupValuesDialogData {
  values: string[];
  fieldLabel: string;
}

@Component({
  selector: 'app-filter-group-values-dialog',
  templateUrl: './filter-group-values-dialog.component.html',
  standalone: false
})
export class FilterGroupValuesDialogComponent {

  rawText: string;

  constructor(
    public dialogRef: MatDialogRef<FilterGroupValuesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: FilterGroupValuesDialogData
  ) {
    this.rawText = (data.values || []).join(' ~ ');
  }

  onOk(): void {
    const values = this.rawText
      .split('~')
      .map(v => v.trim())
      .filter(v => v.length > 0);
    this.dialogRef.close(values);
  }

  onCancel(): void {
    this.dialogRef.close(null);
  }
}
